//All application navigation paths
export const USER = {
  NAME: 'user',
  URL: '/user',
};
export const STUDENT = {
  NAME: 'student',
  URL: '/student',
};

export const SCHOOL = {
  NAME: 'school',
  URL: '/school',
};
export const ADMIN = {
  NAME: 'admin',
  URL: '/admin',
};

export const USER_HOME = {
  NAME: 'home',
  URL: USER.URL + '/home',
};

export const AUTH = {
  NAME: 'auth',
  URL: USER.URL + '/auth',
};

export const CONTACT_US = {
  NAME: 'contact-us',
  URL: USER.URL + '/contact-us',
};

export const TERMS_CONDITION = {
  NAME: 'terms-condition',
  URL: USER.URL + '/terms-condition',
};

export const PRIVACY_POLICY = {
  NAME: 'privacy-policy',
  URL: USER.URL + '/privacy-policy',
};

export const BUY_ACCESS_CODE = {
  NAME: 'buy-access-code',
  URL: USER.URL + '/buy-access-code',
};

export const LOGIN = {
  NAME: 'login',
  URL: AUTH.URL + '/login',
};

export const SIGN_UP = {
  NAME: 'sign-up',
  URL: AUTH.URL + '/sign-up',
};

export const FORGET_PASSWORD = {
  NAME: 'forget-password',
  URL: AUTH.URL + '/forget-password',
};

export const RESET_PASSWORD = {
  NAME: 'reset-password',
  URL: AUTH.URL + '/reset-password',
};

export const VERIFY_PASSWORD = {
  NAME: 'verify-email',
  URL: AUTH.URL + '/verify-email',
};

export const NYCDOE_CALLBACK = {
  NAME: 'nyc/callback',
  URL: '/nyc/callback',
};

export const STUDENT_HOME = {
  NAME: 'home',
  URL: STUDENT.URL + '/home',
};

export const CANVAS_DASHBOARD = {
  NAME: 'dashboard',
  URL: STUDENT.URL + '/dashboard',
};

export const INVITE = {
  NAME: 'invite',
  URL: STUDENT.URL + '/invite',
};
export const MANAGE_STUDENTS = {
  NAME: 'manage-students',
  URL: STUDENT.URL + '/manage-students',
};
export const CANVAS_DASHBOARD_DRIVE_FILES = {
  NAME: 'drive',
  URL: STUDENT.URL + '/drive',
};

export const CHOOSE_MATH_LEVEL = {
  NAME: 'choose-math-level',
  URL: STUDENT.URL + '/choose-math-level',
};

export const FILE_MANAGER = {
  NAME: 'files',
  URL: STUDENT.URL + '/files',
};

export const PLAN_SELECTION = {
  NAME: 'plan-selection',
  URL: STUDENT.URL + '/plan-selection',
};

export const PLAN_SUCCESS = {
  NAME: 'success',
  URL: STUDENT.URL + '/plan-success',
};

export const PLAN_FAILURE = {
  NAME: 'failure',
  URL: STUDENT.URL + '/plan-failure',
};

export const PRINT_FILE = {
  NAME: 'print-canvas',
  URL: STUDENT.URL + '/print-canvas',
};

export const ADMIN_LOGIN = {
  NAME: 'login',
  URL: ADMIN.URL + '/login',
};

export const USER_MANGEMENT = {
  NAME: 'user-management',
  URL: ADMIN.URL + '/user-management',
};

export const DOMAIN_REQUEST_MANGEMENT = {
  NAME: 'domain-request-management',
  URL: ADMIN.URL + '/domain-request-management',
};

export const SUPPORT_MANGEMENT = {
  NAME: 'support-management',
  URL: ADMIN.URL + '/support-management',
};

export const SCHOOL_MANGEMENT = {
  NAME: 'school-management',
  URL: ADMIN.URL + '/school-management',
};

export const EXTEND_SUBSCRIPTION_MANGEMENT = {
  NAME: 'extend-subscription-management',
  URL: ADMIN.URL + '/extend-subscription-management',
};

export const SITE_ADMIN_MANGEMENT = {
  NAME: 'site-admin-management',
  URL: ADMIN.URL + '/site-admin-management',
};

export const SINGLE_ACCESS_CODE = {
  NAME: 'single-access-code',
  URL: ADMIN.URL + '/single-access-code',
};

export const SCHOOL_SIGN_UP = {
  NAME: 'sign-up',
  URL: SCHOOL.URL + '/sign-up',
};

export const SCHOOL_SOCIAL_SIGN_UP = {
  NAME: 'social-sign-up',
  URL: SCHOOL.URL + '/social-sign-up',
};

export const SCHOOL_DASHBOARD = {
  NAME: 'dashboard',
  URL: SCHOOL.URL + '/dashboard',
};
export const SCHOOL_ANALYTICS = {
  NAME: 'analytics',
  URL: SCHOOL.URL + '/analytics',
};
